function GodotGame() {
  return (
     <iframe
      src="FishText.html"
      width="400"
      height="200"
    ></iframe>
  );
}

export default GodotGame;